import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizeHtmlText'
})
export class SanitizeHtmlTextPipe implements PipeTransform {


  constructor(private sanitizer: DomSanitizer) {
  }

  transform(content: string | undefined): SafeHtml | string {
    if (content && typeof window !== 'undefined' && typeof document !== 'undefined') {
      const txt = document.createElement('textarea');
      txt.innerHTML = content;
      const decodedContent = txt.value;
      return decodedContent
        ? this.sanitizer.bypassSecurityTrustHtml(decodedContent)
        : '';
    }
    return '';
  }

}
